import Content from "../../../../../lib/html5-software-library/src/ranj/eng/content/Content";
import NGTScenarioPlayer from "../../../ngt/scenario/NGTScenarioPlayer";
import KeyDecisionDefinition from "./KeyDecisionDefinition";

export default class KeyDecision {
    /**
     * @constructor
     * @param {KeyDecisionDefinition} keyDecisionDefinition 
     * @param {Content} content 
     * @param {NGTScenarioPlayer} contentPlayer 
     */
    constructor(keyDecisionDefinition, content, contentPlayer) {
        this._keyDecisionDefinition = keyDecisionDefinition;
        this._content = content;
        this._contentPlayer = contentPlayer;
    }

    get id() {
        return this._keyDecisionDefinition?.id;
    }

    get chapter() {
        return this._keyDecisionDefinition?.chapter;
    }

    get backgroundImageId() {
        return this._keyDecisionDefinition?.backgroundImageId;
    }

    get content() {
        return this._content;
    }

    get contentPlayer() {
        return this._contentPlayer;
    }

    get baseLpKey() {
        return `keyDecisions.${this.id}`;
    }

    get descriptionLpKey() {
        return `${this.baseLpKey}.descriptionText`;
    }
    
    get actionNeededLpKey() {
        return `${this.baseLpKey}.actionNeededText`;
    }
}